import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
//Limitless imports
import { useExpertMessageResponseContext } from "../../../../expert";
import ExpertDialogueBody from "../../expert-conversation/dialogue/expert-dialogue-body/ExpertDialogueBody";
import Button from "@limitless/modern/inputs/button/Button";
import CheckBox from "@limitless/modern/inputs/checkbox/CheckBox";
import MultilineTextField from "@limitless/modern/inputs/multiline-text-field/MultilineTextField";
const useStyles = makeStyles({
  expertDialogueWrapper: {
    display: "flex",
    padding: "0px 24px 0px 24px",
    "& > :first-child": {
      flex: 1,
      overflowX: "auto"
    }
  },
  aiFeedbackWrapper: {
    display: "flex",
    marginTop: "10px",
    padding: "0px 24px 0px 24px"
  },
  replyContainer: {
    flex: 1,
    maxWidth: "100%"
  },
  actionContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "12px 24px 24px 24px"
  },
  buttonsContainer: {
    display: "flex",
    "& > :first-child": {
      marginRight: 16
    }
  },
  paperWidthSm: {
    maxWidth: 600
  },
  expertDialogueTitle: {
    padding: "24px 24px 16px 24px"
  }
});
const MessageReplyPreviewDialog = ({
  t,
  onSendClick,
  onCancelClick,
  showPreview,
  onShowPreviewChange,
  title,
  showAIFeedback = false,
  children,
  setAiFeedbackText,
  aiFeedbackText
}) => {
  const {
    messageResponse
  } = useExpertMessageResponseContext();
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(Dialog, {
    open: true,
    "aria-labelledby": "replySummaryTitle",
    classes: {
      paper: classes.dialogRoot,
      paperWidthSm: classes.paperWidthSm
    },
    maxWidth: "sm",
    disablePortal: false,
    scroll: "paper",
    onClose: (event, reason) => reason === "backdropClick" && onCancelClick(),
    fullWidth: true
  }, /*#__PURE__*/React.createElement(DialogTitle, {
    id: "replySummaryTitle",
    className: classes.expertDialogueTitle
  }, /*#__PURE__*/React.createElement(Typography, {
    color: "textPrimary",
    variant: "subtitle1",
    component: "span"
  }, t(title))), children, /*#__PURE__*/React.createElement("div", {
    className: classes.expertDialogueWrapper
  }, /*#__PURE__*/React.createElement(ExpertDialogueBody, {
    body: messageResponse,
    containerClass: classes.replyContainer
  })), showAIFeedback && /*#__PURE__*/React.createElement("div", {
    className: classes.aiFeedbackWrapper
  }, /*#__PURE__*/React.createElement(MultilineTextField, {
    id: "feedback-on-ai",
    label: "Feedback on AI",
    type: "textarea",
    multiline: true,
    required: true,
    rows: 1,
    fullWidth: true,
    placeholder: "Type here",
    onChange: e => {
      const value = e.target.value;
      setAiFeedbackText(value);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.actionContainer
  }, onShowPreviewChange ? /*#__PURE__*/React.createElement(CheckBox, {
    onLabel: "Show preview for every reply",
    offLabel: "Show preview for every reply",
    onChange: () => onShowPreviewChange(!showPreview),
    checked: showPreview,
    value: "showPreview",
    variantStyling: {
      padding: "2px 9px 2px 0px !important"
    },
    id: "forwardedCheckbox"
  }) : /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", {
    className: classes.buttonsContainer
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    size: "small",
    id: "cancelButton",
    onClick: onCancelClick
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    size: "small",
    id: "sendClick",
    onClick: onSendClick,
    disabled: showAIFeedback && aiFeedbackText.length <= 10
  }, "Send"))));
};
export default MessageReplyPreviewDialog;
MessageReplyPreviewDialog.propTypes = {
  t: PropTypes.func.isRequired,
  onSendClick: PropTypes.func.isRequired,
  onCancelClick: PropTypes.func.isRequired,
  showPreview: PropTypes.bool,
  onShowPreviewChange: PropTypes.func,
  title: PropTypes.string,
  children: PropTypes.node,
  showAIFeedback: PropTypes.bool,
  setAiFeedbackText: PropTypes.func,
  aiFeedbackText: PropTypes.string
};
MessageReplyPreviewDialog.defaultProps = {
  title: "Reply Preview"
};